import { Dialog, DialogProps } from './Dialog';
import { useAppSelector } from '../../../store';
import { currentModalSelector } from '../selectors';

type Props = Omit<DialogProps, 'show'> & {
  modalKey: string
}

export const Modal = ({ children, modalKey, ...props }: Props) => {

  const currentModal = useAppSelector(currentModalSelector);
  const showing = currentModal === modalKey;

  return (
    <Dialog
      {...props}
      show={showing}
    >
      {children}
    </Dialog>
  );
};
